import React from 'react';
import { stats } from '../data/content';
export function Stats() {
  return <section aria-label="Cifras de la Ruta Clínica GLP-1" className="w-full border-y border-navy-100 bg-cream px-4 py-8 sm:px-6" data-id="element-230" data-mp="2wxqf6edmwmjh">
      <div className="mx-auto grid max-w-3xl grid-cols-2 gap-x-4 gap-y-7 sm:grid-cols-4" data-id="element-231" data-mp="2ix5sv88ig8l8">
        {stats.map(stat => <div key={stat.label} className="text-center" data-id="element-232" data-mp="2nz4y6nnt9fkt">
            <p className="font-serif text-[30px] font-bold leading-none text-navy-900 sm:text-4xl" data-id="element-233" data-mp="29732lfsrx8ql">
              {stat.value}
            </p>
            <p className="mx-auto mt-2 max-w-[150px] text-[11.5px] font-semibold uppercase leading-snug tracking-wide text-navy-700/70" data-id="element-234" data-mp="2e0yxuahnkhi2">
              {stat.label}
            </p>
          </div>)}
      </div>
    </section>;
}